const THEME_STYLE_ELEMENT_ID = 'seathru-theme';

const createStyleEl = () => {
  const ThemeStyleEl = document.createElement('style');

  ThemeStyleEl.setAttribute('id', THEME_STYLE_ELEMENT_ID);
  document.head.appendChild(ThemeStyleEl);

  return ThemeStyleEl;
};

const getColorListTemplate = (theme) => {
  const colorListNames = Object.keys(theme.colorList);

  return colorListNames.map((colorName) => `--seathru-${colorName}-color: ${theme.colorList[colorName]};`).join('');
};

export const setCssVariables = (theme) => {
  let ThemeStyleEl = document.getElementById(THEME_STYLE_ELEMENT_ID);
  const colorList = getColorListTemplate(theme);

  if (!ThemeStyleEl) {
    ThemeStyleEl = createStyleEl();
  }

  ThemeStyleEl.textContent = `
    :root {
      ${colorList}
      --seathru-font-size-base:${theme.fontOptionList.baseSize};
    }
  `;
};

export const initCssVariables = () => {
  setCssVariables();
};
